module.exports = __webpack_public_path__ + "static/media/same_segment1.1ff7f8da.jpg";